// extracted by css-extract-rspack-plugin
export default {"link":"src-Link-link-d9181862"};